import React from 'react';
import CategoryMultiSelect from './CategoryMultiSelect';
import AlertsFilterDropdown from './AlertsFilterDropdown';

const CATEGORY_OPTIONS = [
  { value: 'Maintenance', label: 'Maintenance' },
  { value: 'Compliance & Coverage', label: 'Compliance & Coverage' },
  { value: 'Financial', label: 'Financial' },
  { value: 'Approvals', label: 'Approvals' },
  { value: 'Complaints', label: 'Complaints' },
  { value: 'Transfers', label: 'Transfers' },
  { value: 'Other', label: 'Other' },
];

const GROUP_BY_OPTIONS = [
  { value: 'timeline', label: 'Timeline (Today, This Week, ...)' },
  { value: 'category', label: 'Category (Type, Maintenance, ...)' },
  { value: 'severity', label: 'Severity (Critical, Warning, Info)' },
  { value: 'device', label: 'Device (Device Name)' },
  { value: 'department', label: 'Department (Department Name)' },
];

const SEVERITY_OPTIONS = [
  { value: 'all', label: 'All Severities' },
  { value: 'critical', label: '🔴 Critical Only' },
  { value: 'warning', label: '⚠️ Warnings Only' },
  { value: 'info', label: 'ℹ️ Info Only' },
];

/**
 * AlertFilters Component - Inline filtering UI (Legacy Phase 1)
 * Advanced filters (locations, dates) moved to Advanced Filters Drawer
 * Phase 1 (Legacy): Group by, severity, category, search
 */
function AlertFilters({
  groupBy,
  setGroupBy,
  filterPriority,
  setFilterPriority,
  filterCategories,
  setFilterCategories,
  searchQuery,
  setSearchQuery,
  categories = [],
  onPriorityChange,
  onSearchChange,
  onCategoryChange,
}) {
  return (
    <div className="alerts-filters-section">
      <div className="search-bar">
        <div className="search-input-wrapper">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search device, complaint, site, or message..."
            value={searchQuery}
            onChange={(e) => {
              const searchValue = e.target.value;
              setSearchQuery(searchValue);
              if (onSearchChange) {
                onSearchChange(searchValue);
              }
            }}
            className="search-input"
          />
          {searchQuery && (
            <button
              className="search-clear"
              onClick={() => {
                setSearchQuery('');
                if (onSearchChange) {
                  onSearchChange('');
                }
              }}
              title="Clear search"
              aria-label="Clear search"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      <div className="filters-control-row">
        <div className="filter-group">
          <label>
            📊 Group By{' '}
            <span style={{ color: '#d32f2f', fontWeight: '500' }}>
              (Current Page)
            </span>
            <span
              title="Groups organize alerts on the current page. To see more grouped data, increase the page size (up to 100). Groups may appear incomplete across different pages."
              style={{ marginLeft: '0.5rem', cursor: 'help', fontSize: '0.85rem', opacity: 0.7 }}
            >
              ⓘ
            </span>
          </label>
          <AlertsFilterDropdown
            options={GROUP_BY_OPTIONS}
            value={groupBy}
            onChange={setGroupBy}
            title="Organize alerts by Timeline, Category, Priority, Device, or Department. Grouping applies to current page results."
          />
        </div>

        <div className="filter-group">
          <label>
            🎯 Severity
            <span
              title="Server-side filter - reduces the dataset before pagination. Affects all pages."
              style={{ marginLeft: '0.5rem', cursor: 'help', fontSize: '0.85rem', opacity: 0.7 }}
            >
              ⓘ
            </span>
          </label>
          <AlertsFilterDropdown
            options={SEVERITY_OPTIONS}
            value={filterPriority}
            onChange={(val) => {
              setFilterPriority(val);
              if (onPriorityChange) {
                onPriorityChange(val);
              }
            }}
            title="Filter by severity level (server-side). Updates the dataset for all pages."
          />
        </div>

        <div className="filter-group">
          <label>
            🏷️ Category
            <span
              title="Server-side filter - reduces the dataset before pagination. Affects all pages."
              style={{ marginLeft: '0.5rem', cursor: 'help', fontSize: '0.85rem', opacity: 0.7 }}
            >
              ⓘ
            </span>
          </label>
          <CategoryMultiSelect
            options={CATEGORY_OPTIONS}
            selected={filterCategories}
            onChange={(selected) => {
              setFilterCategories(selected);
              if (onCategoryChange) {
                onCategoryChange(selected);
              }
            }}
            title="Filter by category (server-side). Select one or more. Updates all pages."
          />
        </div>
      </div>
    </div>
  );
}

export default AlertFilters;
